import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 leading-tight mb-4">
            Start Using the Most Updated{" "}
            <span className="text-primary-600">ACBuy Spreadsheet</span>{" "}
            Today
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
            Join thousands of global buyers who rely on verified product data, updated supplier lists, and organized categories to source smarter and faster.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Get Access Now
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-800 text-base font-semibold hover:border-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              ACBuy Spreadsheet
              <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>

        {/* Image Banner */}
        <div className="mt-14 flex gap-3 md:gap-4 justify-center flex-wrap">
          {[
            "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20sneakers%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20elegant%20composition&width=300&height=300&seq=cta-product-01&orientation=squarish",
            "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20hoodie%20on%20clean%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20elegant%20composition&width=300&height=300&seq=cta-product-02&orientation=squarish",
            "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20backpack%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20elegant%20composition&width=300&height=300&seq=cta-product-03&orientation=squarish",
            "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20cap%20hat%20on%20clean%20beige%20background%2C%20soft%20studio%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20elegant%20composition&width=300&height=300&seq=cta-product-04&orientation=squarish",
            "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20perfume%20bottle%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20elegant%20composition&width=300&height=300&seq=cta-product-05&orientation=squarish",
          ].map((url, idx) => (
            <div
              key={idx}
              className="w-20 h-20 md:w-24 md:h-24 rounded-2xl overflow-hidden bg-background-100 flex-shrink-0"
            >
              <img
                src={url}
                alt="Product preview from acbuy spreadsheet"
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}